import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import get from 'lodash/get';
import { isNullOrEmpty } from '../../../../../utils/vuex';
import CoreDtwinStateBridgeMqtt from '@/components/core/dtwin/state/bridge/mqtt';
import CoreDtwinStateBridgeNiota from '@/components/core/dtwin/state/bridge/niota';
import CoreDtwinStateBridgeOpenweather from '@/components/core/dtwin/state/bridge/openweather';
import CoreDtwinStateBridgeWebsocket from '@/components/core/dtwin/state/bridge/websocket';
import CoreDtwinStateBridgeIncomingwebhook from '@/components/core/dtwin/state/bridge/incomingwebhook';
import ApiService from '@/services/apiService';
import iconsMixin from '@/components/core/dtwin/state/bridge/iconsMixin';
export default {
  name: 'CoreDtwinStateBridgeEdit',
  components: {
    CoreDtwinStateBridgeMqtt: CoreDtwinStateBridgeMqtt,
    CoreDtwinStateBridgeNiota: CoreDtwinStateBridgeNiota,
    CoreDtwinStateBridgeOpenweather: CoreDtwinStateBridgeOpenweather,
    CoreDtwinStateBridgeWebsocket: CoreDtwinStateBridgeWebsocket,
    CoreDtwinStateBridgeIncomingwebhook: CoreDtwinStateBridgeIncomingwebhook
  },
  mixins: [iconsMixin],
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    // is this an 'edit', 'create'?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    },
    bridgeConfigs: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    },
    vdTenantId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      selectedBridgeConfig: null,
      loading: false,
      localBridgeConfigs: _toConsumableArray(this.bridgeConfigs),
      showRetryButton: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), mapState('authentication', ['tenantId'])), {}, {
    hasManageAllPermissions: function hasManageAllPermissions() {
      return this.permissions['all.manage'];
    },
    baseBridgeType: function baseBridgeType() {
      return (get(this.selectedBridgeConfig, 'type') || '').replace(/^bridge-/, '');
    },
    bridgeComponentExists: function bridgeComponentExists() {
      if (!this.baseBridgeType) {
        return false;
      }

      return this.$options.components["CoreDtwinStateBridge".concat(this.baseBridgeType[0].toUpperCase()).concat(this.baseBridgeType.slice(1))];
    },
    formIsValid: function formIsValid() {
      return (// if a bridge has no UI, mark it as valid in any case
        !this.bridgeComponentExists || !isNullOrEmpty(this.selectedBridgeConfig) && this.$refs["".concat(this.baseBridgeType, "-bridge-config")] && this.$refs["".concat(this.baseBridgeType, "-bridge-config")].formIsValid
      );
    }
  }),
  watch: {
    selectedBridgeConfig: function selectedBridgeConfig(val) {
      var _this = this;

      if (this.lclModel && val && val.configId) {
        this.lclModel.properties.binding.options.configId = val.configId;
        this.lclModel.properties.binding.options.virtualDevice = undefined;
      }

      if (!this.loading) {
        this.$nextTick(function () {
          if (!isNullOrEmpty(_this.$refs.bridgeConfigs)) {
            var dsInput = _this.$refs.bridgeConfig.$el.querySelector('input');

            dsInput.blur();
          }
        });
      }
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.mode === 'create' || this.mode === 'import') {
      if (this.bridgeConfigs && this.bridgeConfigs.length === 1) {
        this.selectedBridgeConfig = this.bridgeConfigs[0];
      }
    } else {
      this.loading = true; // prevent the auto-complete field to be unnecessarily focused (see watcher `selectedBridgeConfig`)

      this.selectedBridgeConfig = this.bridgeConfigs.find(function (ds) {
        return ds.configId === parseInt(_this2.lclModel.properties.binding.options.configId);
      });

      if (!this.selectedBridgeConfig) {
        this.showRetryButton = true;
      }
    }
  },
  methods: {
    openBridgeConfig: function openBridgeConfig() {
      this.$router.push({
        path: "/connectors/edit/".concat(this.selectedBridgeConfig.tenantId, "/").concat(this.selectedBridgeConfig.configId)
      });
    },
    bridgeBindingChanged: function bridgeBindingChanged(val) {
      this.$emit('bridge-binding-changed', val);
      this.loading = false;
    },
    saveState: function saveState() {
      this.lclModel.properties.binding.options.configId = get(this.selectedBridgeConfig, 'configId');

      if (this.formIsValid && this.bridgeComponentExists) {
        this.$refs["".concat(this.baseBridgeType, "-bridge-config")].saveState();
      }
    },
    bridgeConfig: function bridgeConfig(bridge, types) {
      var foundMatch = types.find(function (config) {
        return config.type === bridge.type;
      });
      return foundMatch;
    },
    loadBridgeConfigs: function loadBridgeConfigs() {
      return Promise.all([ApiService.getBridgeTypes(), ApiService.getBridgesForTenant(this.vdTenantId)]);
    },
    retryFetchBridges: function () {
      var _retryFetchBridges = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loadBridgeConfigs().then(function (configData) {
                  var types = configData[0];
                  var configs = configData[1];
                  _this3.localBridgeConfigs = configs.filter(function (config) {
                    return get(_this3.bridgeConfig(config, types), 'manifest.functionScope.invokeDirection.inbound');
                  }).map(function (config) {
                    return {
                      type: config.type,
                      image: _this3.bridgeTypesIcons[config.type],
                      title: config.name,
                      configId: config.id,
                      tenantId: config.tenantId
                    };
                  });
                  _this3.selectedBridgeConfig = _this3.localBridgeConfigs.find(function (ds) {
                    return ds.configId === parseInt(_this3.lclModel.properties.binding.options.configId);
                  });

                  if (_this3.selectedBridgeConfig) {
                    _this3.showRetryButton = false;
                  }
                }).catch(function (error) {
                  _this3.$snack(_this3.$i18n_t('Connectors.Connectors.errors.errorWhileFetchingConnectos'), 'error');

                  console.error('Error', error);
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function retryFetchBridges() {
        return _retryFetchBridges.apply(this, arguments);
      }

      return retryFetchBridges;
    }()
  }
};